import React from 'react';
import './AboutPopup.css';

const AboutPopup = ({ onClose }) => {
  return (
    <div className="about-popup-overlay" onClick={onClose}>
      <div className="about-popup" onClick={(e) => e.stopPropagation()}>
        <div className="about-popup-content">
          <p>
            anicha.earth is a simple and easy-to-use web service that lets you pick an area on the map and instantly see its history of changes since 2018, with updates every few days from Sentinel‑2 satellites.
          </p>
          <p>
            The service gathers all available images of your selected area from the past years, presenting them in a timeline and on the map. Sentinel‑2 images have a resolution of 10 m per pixel, but we enhance them to 1–2 m using a special AI model trained on millions of satellite photos.
          </p>
          <p>
            It's still not quite at Google Maps' level of sharpness—we can't produce crystal-clear images—but unlike Google, we can show you what any location looked like every few days over the last seven years.
          </p>
          <div className="contact-info">
            <p>
              The project is in early beta testing, so any ideas and suggestions are very welcome!
            </p>
            <a href="mailto:konstantin@anicha.earth" className="contact-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              konstantin@anicha.earth
            </a>
            <a href="https://t.me/shivaberdad" target="_blank" rel="noopener noreferrer" className="contact-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" fill="currentColor"/>
                <path d="M8.85 11.12l7.1-2.87c.33-.13.62-.02.51.38l-1.21 5.72c-.09.41-.33.51-.67.32l-1.85-1.36-1.28 1.23c-.14.14-.26.26-.54.26l.19-2.53 4.89-4.42c.21-.19-.05-.3-.33-.11l-6.04 3.8-2.6-.81c-.57-.18-.58-.57.12-.84z" fill="white"/>
              </svg>
              @shivaberdad
            </a>
            <a href="/about" className="contact-link about-page-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5l7 7-7 7M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              About the project
            </a>
            <div className="terms-link-container">
              <a href="/terms" className="terms-link">Terms and Conditions</a>
              <a href="/privacy" className="terms-link">Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPopup;
